import "./views/movie/mobile/partials/_carousel.js";
import "./views/movie/mobile/partials/_castCarousel.js";
import "./views/movie/shared/partials/_imgGalleryScroll.js";